import {FilterObject} from "./filter-object";

export class TypesContratFilter extends FilterObject<any> {

    public filter(itemToFiltre: any): boolean {
        return this.doFilter(itemToFiltre, this.field, this.values);
    }

    public doFilter(itemToFiltre: any, field: any, value: any): boolean {
        if (itemToFiltre[field]) {
            return value.indexOf(itemToFiltre[field]) > -1;
        }
        return true;
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/types-contrat.filter.ts